import type { ComputedRef, InjectionKey, Ref } from 'vue'
import type { ClientItem } from '@/views/dashboard/_type/client-item'
import type { ClientService, ExecuteTerminalActionOptions, FetchOptions } from './client.service'

/**
 * 终端管理页（client.vue）向 GroupClientTerminalListSection 注入的上下文：
 * 列表工具栏、排序、筛选、批量操作等统一走 inject，避免预览列表与抽屉内列表各传一套函数 props 导致重复触发与难以维护。
 */
export interface GroupClientPageContext {
  /** client.vue 中 reactive(data)，含 options / state / checkedColumns 等 */
  data: any
  clientService: ClientService
  fetchData: (options: FetchOptions, isOperatePage?: boolean) => Promise<void>
  executeTerminalAction: (options: ExecuteTerminalActionOptions) => Promise<unknown>
  ignoreTableSelectionChangeFromSync: Ref<boolean>
  status: ComputedRef<{ options: { value: number; label: string }[] }>
  AlltableColumns: ComputedRef<Array<{ c_key: string; c_name: string }>>
  ModulePermissionKey: Record<number, string>
  openTerminalListDrawer: () => void
  terminalInfoVisible: Ref<boolean>
  serviceManageVisible: Ref<boolean>
  locationInfoVisible: Ref<boolean>
  fleetMapVisible: Ref<boolean>
  getRemoteDisableTip: (item: ClientItem) => string | null
  terminalGroupIdSelected: (groupId: number) => void
}

export const GroupClientPageKey: InjectionKey<GroupClientPageContext> = Symbol('groupClientPage')
